import React, { useState, useCallback } from 'react';
import {
  ChatStartersSectionContainer,
  ChatStartersContainer,
  ChatStarterInputWrapper,
  ChatStarterInput,
} from '../ConfigPage.styled';
import { Typography, Icon } from '@ann/web-components';

const ChatStartersSection = ({ chatStarters = [], onAddStarter, onRemoveStarter }) => {
  const [newStarter, setNewStarter] = useState('');

  const handleAdd = useCallback(() => {
    if (newStarter.trim()) {
      onAddStarter?.(newStarter.trim());
      setNewStarter('');
    }
  }, [newStarter, onAddStarter]);

  const handleKeyPress = useCallback((e) => {
    if (e.key === 'Enter') {
      handleAdd();
    }
  }, [handleAdd]);

  const handleRemove = useCallback((index) => {
    onRemoveStarter?.(index);
  }, [onRemoveStarter]);

  return (
    <ChatStartersSectionContainer>
      <Typography category="subtitle" weight="bold" color="title" size="medium">
        Chat Starters
      </Typography>

      <ChatStartersContainer>
        {chatStarters.map((starter, index) => (
          <ChatStarterInputWrapper key={index}>
            <ChatStarterInput
              value={starter}
              readOnly
            />
            <Icon
              name="close"
              size="medium"
              onClick={() => handleRemove(index)}
              style={{ cursor: 'pointer' }}
            />
          </ChatStarterInputWrapper>
        ))}

        <ChatStarterInputWrapper>
          <ChatStarterInput
            placeholder="Enter a chat starter"
            value={newStarter}
            onChange={(e) => setNewStarter(e.target.value)}
            onKeyPress={handleKeyPress}
          />
          <Icon
            name="plus"
            size="medium"
            onClick={handleAdd}
            style={{ cursor: 'pointer' }}
          />
        </ChatStarterInputWrapper>
      </ChatStartersContainer>
    </ChatStartersSectionContainer>
  );
};

export default ChatStartersSection;

